/* ============================================================
   SWORDSLIFE OZEL SCRIPT
   SWORDSLIFE-OZEL (yeni dosya, tema guncellemesinde kalir). Defter: snippets/swordslife-changelog.liquid
   Tema guncellemelerinde silinmesin diye ayri dosyada.
   layout/theme.liquid icinde defer ile yuklenir.
   (2026-10-08: eski temanin layout/theme.liquid sonundan tasindi)
   ============================================================ */

/* --- 1) MOBIL BASLIK (<= 768px) ---
   Baslik altindaki bosluk/ayirici/duyuru cubugu ogelerini gizler, baslik ile
   ilk bolum arasindaki boslugu kapatir, asagi kaydirinca basligi gizler
   (header--hidden), en uste donunce gosterir. */
(function () {
  function isMobile() {
    return window.innerWidth <= 768;
  }

  function waitForHeader(callback) {
    var check = setInterval(function () {
      var header =
        document.querySelector('.header') ||
        document.querySelector('.shopify-section-header') ||
        document.querySelector('header');
      if (header) {
        clearInterval(check);
        callback(header);
      }
    }, 150);
  }

  function initMobileHeaderFix(header) {
    if (!isMobile()) return;

    // Ayni anda iki kez calismasini onle
    if (header.dataset.fixed === '1') return;
    header.dataset.fixed = '1';

    var spacerSel = [
      '.header__spacer', '.header__sticky-spacer', '.header__placeholder',
      '.header__height', '.header__bottom', '.header__line', '.header__border',
      '.announcement-bar'
    ].join(',');

    document.querySelectorAll(spacerSel).forEach(function (el) {
      el.style.display = 'none';
      el.style.height = '0';
      el.style.minHeight = '0';
      el.style.margin = '0';
      el.style.padding = '0';
      el.style.border = '0';
    });

    var headerSection = header.closest('.shopify-section');
    var nextSection =
      (headerSection && headerSection.nextElementSibling) ||
      document.querySelector('#MainContent .shopify-section');

    function squashGap() {
      if (!nextSection) return;
      var hb = header.getBoundingClientRect().bottom + window.scrollY;
      var ct = nextSection.getBoundingClientRect().top + window.scrollY;
      var gap = Math.max(0, ct - hb);
      if (!nextSection.dataset.mt) {
        nextSection.dataset.mt = getComputedStyle(nextSection).marginTop.replace('px', '') || '0';
      }
      var base = parseFloat(nextSection.dataset.mt) || 0;
      nextSection.style.marginTop = (base - gap) + 'px';
    }

    var lastY = window.scrollY || 0;
    function onScroll() {
      var y = window.scrollY || 0;
      if (y > lastY && y > 5) {
        header.classList.add('header--hidden');
      } else if (y <= 0) {
        header.classList.remove('header--hidden');
      }
      lastY = y;
      squashGap();
    }

    squashGap();
    onScroll();
    window.addEventListener('scroll', function () { requestAnimationFrame(onScroll); }, { passive: true });
    window.addEventListener('resize', function () {
      if (!isMobile()) resetMobileFix();
    }, { passive: true });
  }

  function resetMobileFix() {
    document.querySelectorAll('.header--hidden').forEach(function (h) { h.classList.remove('header--hidden'); });
    document.querySelectorAll('[data-mt]').forEach(function (el) {
      el.style.marginTop = el.dataset.mt + 'px';
    });
    document.querySelectorAll('[data-fixed="1"]').forEach(function (h) {
      delete h.dataset.fixed;
    });
  }

  // Tema duzenleyicisinde bolum yeniden yuklenince
  document.addEventListener('shopify:section:load', function () {
    if (isMobile()) waitForHeader(initMobileHeaderFix);
  });
  document.addEventListener('shopify:section:unload', resetMobileFix);

  // Sayfa tamamen yuklenince baslat
  window.addEventListener('load', function () {
    if (isMobile()) waitForHeader(initMobileHeaderFix);
  });

  // Mobil <-> masaustu gecisini takip et
  window.addEventListener('resize', function () {
    if (isMobile()) waitForHeader(initMobileHeaderFix);
    else resetMobileFix();
  });
})();

/* --- 2) KOLEKSIYON ARAC CUBUGU ---
   Filtre/siralama cubugu kaydirinca yapissin, cekmece veya mega menu
   acikken gizlensin. Stil: swordslife-custom.css */
(function () {
  if (!document.body || !document.body.classList.contains('collection-template')) return;
  var toolbar = document.querySelector('.sticky-element:has(.collection__toolbar)');
  if (!toolbar) return;

  toolbar.style.transition = 'opacity 0.2s ease';

  window.addEventListener('scroll', function () {
    if (window.scrollY > 10) {
      toolbar.classList.add('toolbar-is-sticky');
    } else {
      toolbar.classList.remove('toolbar-is-sticky');
    }
  }, { passive: true });

  function checkOverlays() {
    var anyOpen = document.querySelector('.drawer[active], .mega-menu[open]');
    toolbar.style.opacity = anyOpen ? '0' : '1';
    toolbar.style.pointerEvents = anyOpen ? 'none' : '';
  }
  new MutationObserver(checkOverlays).observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['active', 'open']
  });
})();

/* --- 3) KART VIDEOLARI (custom.video) ---
   Kart ekranin en az yarisina girince video indirilir ve sessiz oynar, cikinca durur.
   Veri tasarrufu veya "hareketi azalt" acikken oynatilmaz. Link bozuksa video kaldirilir, resim kalir. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  if (reduce || saveData) return;

  /* SWORDSLIFE-OZEL v2 (2026-10-30) AKILLI OYNATMA: kaydirirken video INMEZ (hiz).
     Masaustu: fare kartin ustunde 0,3 sn durunca oynar, cikinca durur.
     Telefon: kaydirma durup kart ekranda ~0,9 sn kalinca, ekranin ortasina en yakin TEK kart oynar. */
  var hover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var vis = new Map(), dwellT = null, lastScroll = 0;
  function play(v) { if (!v.getAttribute('src') && v.dataset.src) v.setAttribute('src', v.dataset.src); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function stop(v) { if (!v.paused) v.pause(); }
  function pickCenter() {
    var best = null, bd = 1e9, mid = window.innerHeight / 2;
    vis.forEach(function (ratio, v) { if (ratio < 0.7) return; var r = v.getBoundingClientRect(), d = Math.abs((r.top + r.bottom) / 2 - mid); if (d < bd) { bd = d; best = v; } });
    document.querySelectorAll('video.pcard-video.is-playing').forEach(function (v) { if (v !== best) { stop(v); v.classList.remove('is-playing'); } });
    if (best) play(best);
  }
  function armDwell() { clearTimeout(dwellT); dwellT = setTimeout(function () { if (Date.now() - lastScroll >= 800) pickCenter(); }, 900); }
  if (!hover) window.addEventListener('scroll', function () { lastScroll = Date.now(); document.querySelectorAll('video.pcard-video.is-playing').forEach(function (v) { var r = v.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) { stop(v); v.classList.remove('is-playing'); } }); armDwell(); }, { passive: true });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) vis.set(v, en.intersectionRatio); else { vis.delete(v); stop(v); v.classList.remove('is-playing'); }
    });
    if (!hover) armDwell();
  }, { threshold: [0, 0.4, 0.7, 1] });
  function bindHover(v) {
    var card = v.closest('.product-card') || v.parentNode; if (!card || card._slHv) return; card._slHv = 1; var t = null;
    card.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(function () { play(v); }, 300); });
    card.addEventListener('mouseleave', function () { clearTimeout(t); stop(v); v.classList.remove('is-playing'); });
  }

  function bind() {
    document.querySelectorAll('video.pcard-video:not([data-pcv])').forEach(function (v) {
      v.setAttribute('data-pcv', '1');
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      v.addEventListener('pause', function () { v.classList.remove('is-playing'); });
      v.addEventListener('error', function () { io.unobserve(v); v.remove(); });
      if (hover) bindHover(v); else io.observe(v);
    });
  }

  function start() {
    bind();
    // Filtre, siralama, "daha fazla goster" ile sonradan gelen kartlar icin
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; bind(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* SWORDSLIFE-OZEL: Cikis (logout) sonrasi duzeltme.
   Yeni musteri hesaplarinda cikis linkine "geri don" adresi verilemiyor ve donulen sayfa bazen eski (girisli) hali gosteriyor.
   Cikisa tiklaninca bulunulan sayfa kaydedilir; donuste sayfa hala girisli gorunuyorsa bir kez yenilenir,
   sonra musteri kaldigi sayfaya (ornegin urun sayfasi) geri goturulur. */
(function () {
  var KEY = 'sl_logout';
  function get() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function set(v) { try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function clear() { try { sessionStorage.removeItem(KEY); } catch (e) {} }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/account/logout"], a[href*="customer_authentication/logout"]');
    if (a) set({ to: location.pathname + location.search, t: Date.now(), n: 0 });
  }, true);

  function check() {
    var d = get();
    if (!d) return;
    if (!d.t || Date.now() - d.t > 120000) { clear(); return; }
    var stillSignedIn = !!document.querySelector('[data-account-menu]');
    if (stillSignedIn) {
      if ((d.n || 0) >= 2) { clear(); return; }
      d.n = (d.n || 0) + 1;
      set(d);
      location.reload();
      return;
    }
    clear();
    var here = location.pathname + location.search;
    if (d.to && d.to !== here && d.to.charAt(0) === '/') location.replace(d.to);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
  window.addEventListener('pageshow', function (e) { if (e.persisted) check(); });
})();

/* SWORDSLIFE-OZEL: Mobil menu ekleri - dil ve ulke/bolge secimi (snippets/mobile-menu-extras.liquid).
   Olay yetkilendirmesi ile calisir; panel body'ye tasinsa da etkilenmez. */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-mx-lang], [data-mx-c], [data-mx-toggle]');
    if (!t) return;
    var f = t.closest('form');
    if (!f) return;
    e.preventDefault();
    if (t.hasAttribute('data-mx-toggle')) {
      var list = f.querySelector('[data-mx-list]');
      if (!list) return;
      var willOpen = list.hidden;
      list.hidden = !willOpen;
      t.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) {
        var cur = list.querySelector('.mx-country.is-active');
        if (cur) cur.scrollIntoView({ block: 'nearest' });
      }
      return;
    }
    if (t.classList.contains('is-active')) return;
    if (t.hasAttribute('data-mx-lang')) f.querySelector('[data-mx-locale]').value = t.getAttribute('data-mx-lang');
    else f.querySelector('[data-mx-country]').value = t.getAttribute('data-mx-c');
    f.submit();
  });
  document.addEventListener('input', function (e) {
    var s = e.target;
    if (!s.matches || !s.matches('[data-mx-search]')) return;
    var q = s.value.trim().toLowerCase();
    var list = s.closest('[data-mx-list]');
    if (!list) return;
    list.querySelectorAll('[data-mx-c]').forEach(function (b) {
      b.parentNode.hidden = !!q && b.getAttribute('data-mx-name').indexOf(q) < 0;
    });
  });
})();

/* ------------------------------------------------------------
   SWORDSLIFE-OZEL: PROFIL RESMI (avatar) - 2026-10-09
   window.slAvatar: My Account sayfasi (sections/sl-account.liquid) ve header'daki
   [data-sl-avatar] alanlarini boyar. Musteri kimligi [data-sl-cid] / [data-cid] dan okunur.
   Kayit simdilik bu tarayicida (localStorage 'sl_avatar_<musteri id>').
   Deger: {t:'img', d:dataURL} | {t:'emo', e:'🦊', g:gradyanNo} | yok (bas harf)
   ------------------------------------------------------------ */
(function () {
  var grads = [
    'linear-gradient(135deg,#ff9a76,#e5322d)', 'linear-gradient(135deg,#ffd36e,#ff7a3d)',
    'linear-gradient(135deg,#9be15d,#00b37e)', 'linear-gradient(135deg,#63e2ff,#2a7bff)',
    'linear-gradient(135deg,#b993ff,#6a3df0)', 'linear-gradient(135deg,#ff9ad5,#e83e8c)',
    'linear-gradient(135deg,#7f8cff,#1e2a78)', 'linear-gradient(135deg,#2b3f9e,#0b1030)',
    'linear-gradient(135deg,#ffe29f,#ffa99f)', 'linear-gradient(135deg,#a8edea,#4fb3a9)',
    'linear-gradient(135deg,#f6d365,#fda085)', 'linear-gradient(135deg,#3a3d46,#0f1115)'
  ];
  var emo = ['🦊','🐼','🐨','🦁','🐯','🐸','🐵','🦄','🐙','🐳','🌵','🌸','⚡','🔥','🎧','🚀'];
  var presets = emo.map(function (e, i) { return { e: e, g: i % grads.length }; });
  function grad(i) { return grads[(Number(i) || 0) % grads.length]; }
  function key(cid) { return 'sl_avatar_' + cid; }
  function get(cid) {
    if (!cid) return null;
    try { return JSON.parse(localStorage.getItem(key(cid)) || 'null'); } catch (e) { return null; }
  }
  /* 2026-10-09: sunucu kaydi (Cloudflare Worker, App Proxy /apps/sl-account) -> her cihazda ayni resim */
  var API = '/apps/sl-account/';
  function save(cid, v) {
    try { if (v) localStorage.setItem(key(cid), JSON.stringify(v)); else localStorage.removeItem(key(cid)); } catch (e) {}
  }
  function push(v) {
    return fetch(API + 'avatar', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ value: v || null }) })
      .then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  function set(cid, v) {
    if (!cid) return Promise.resolve(false);
    save(cid, v);
    applyAll(true);
    return push(v);
  }
  function pull(cid) {
    var k = 'sl_ava_pull_' + cid;
    try { if (sessionStorage.getItem(k)) return; sessionStorage.setItem(k, '1'); } catch (e) { return; }
    fetch(API + 'me', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.ok || !j.customer) return;
        var sv = j.customer.avatar || null, lv = get(cid);
        if (!sv && lv) { push(lv); return; }
        if (JSON.stringify(sv) !== JSON.stringify(lv)) { save(cid, sv); applyAll(true); }
      }).catch(function () {});
  }
  function paint(el, v, initial) {
    if (!el) return;
    if (!el.hasAttribute('data-sl-bg0')) el.setAttribute('data-sl-bg0', el.style.background || '');
    el.classList.remove('sl-ava-emo', 'sl-ava-has-img');
    el.style.background = el.getAttribute('data-sl-bg0');
    if (v && v.t === 'img' && v.d) {
      el.innerHTML = '';
      var img = document.createElement('img');
      img.className = 'sl-ava-pic';
      img.alt = '';
      img.src = v.d;
      el.appendChild(img);
      el.classList.add('sl-ava-has-img');
    } else if (v && v.t === 'emo' && v.e) {
      el.textContent = v.e;
      el.style.background = grad(v.g);
      el.classList.add('sl-ava-emo');
    } else if (window.slShopAva && window.slShopAva.img) {
      /* SWORDSLIFE-OZEL (2026-10-09): kendi resmi yoksa Shop/Google profil resmi */
      el.innerHTML = '';
      var gimg = document.createElement('img');
      gimg.className = 'sl-ava-pic';
      gimg.alt = '';
      gimg.referrerPolicy = 'no-referrer';
      gimg.src = window.slShopAva.img;
      el.appendChild(gimg);
      el.classList.add('sl-ava-has-img');
    } else {
      el.textContent = initial || el.getAttribute('data-initial') || '';
      /* SWORDSLIFE-OZEL (2026-10-09): Shopify'in verdigi harf rengi */
      /* Shopify'in harf rengi siyah geliyordu: her zaman Google renklerinden biri */
      el.style.background = letterColor(cidNow());
      el.style.color = '#fff';
    }
  }
  /* SWORDSLIFE-OZEL (2026-10-09): Google tarzi renkli harf - musteri numarasindan sabit renk (her giriste ayni) */
  var LETTER = ['#F4511E', '#E67C73', '#D50000', '#EF6C00', '#F6BF26', '#C0CA33', '#33B679', '#0B8043', '#009688', '#039BE5', '#3F51B5', '#7986CB', '#8E24AA', '#AD1457', '#795548']; /* gri/siyah/beyaz tonlari yok */
  function letterColor(id) {
    /* header.liquid'deki ile ayni hesap: musteri no % 15 */
    var n = Number(String(id || '').replace(/\D/g, '')) || 0;
    return LETTER[n % LETTER.length];
  }
  function cidNow() {
    var n = document.querySelector('[data-sl-cid],[data-cid]');
    return n ? (n.getAttribute('data-sl-cid') || n.getAttribute('data-cid')) : '';
  }
  function applyAll(skipPull) {
    var cid = cidNow();
    if (!cid) return;
    var v = get(cid);
    document.querySelectorAll('[data-sl-avatar]').forEach(function (el) { paint(el, v); });
    if (skipPull !== true) pull(cid);
  }
  function fromFile(f) {
    return new Promise(function (res, rej) {
      if (!f || !/^image\//.test(f.type)) return rej(new Error('type'));
      var r = new FileReader();
      r.onerror = rej;
      r.onload = function () {
        var im = new Image();
        im.onerror = rej;
        im.onload = function () {
          var s = Math.min(im.naturalWidth, im.naturalHeight), S = 256;
          var c = document.createElement('canvas');
          c.width = c.height = S;
          var x = c.getContext('2d');
          x.fillStyle = '#fff';
          x.fillRect(0, 0, S, S);
          x.drawImage(im, (im.naturalWidth - s) / 2, (im.naturalHeight - s) / 2, s, s, 0, 0, S, S);
          res(c.toDataURL('image/jpeg', 0.86));
        };
        im.src = r.result;
      };
      r.readAsDataURL(f);
    });
  }
  window.slAvatar = { presets: presets, grads: grads, grad: grad, get: get, set: set, paint: paint, applyAll: applyAll, fromFile: fromFile };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { applyAll(); }); else applyAll();
  window.addEventListener('storage', function (e) { if (e.key && e.key.indexOf('sl_avatar_') === 0) applyAll(true); });
})();

/* ------------------------------------------------------------
   SWORDSLIFE-OZEL (2026-10-09) HIZ: mobil menu cekmecesindeki resimli koleksiyon izgaralari
   snippets/menu-drawer-details.liquid icinde <template data-sl-lazy> olarak gelir.
   Bir menu basligina dokunulunca (summary tiklamasi / details acilisi) icerik sayfaya eklenir.
   ------------------------------------------------------------ */
(function () {
  /* SWORDSLIFE-OZEL v347 (2026-10-31): sayfada sadece yazili linkler var; resimli izgara sections/sl-menu-grids'den BIR KEZ istenir ve yerine konur */
  var G = null, GP = null;
  function grids() {
    if (GP) return GP;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    GP = fetch(root + '?section_id=sl-menu-grids', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) {
      G = {}; var d = document.createElement('div'); d.innerHTML = h;
      d.querySelectorAll('template[data-slg]').forEach(function (t) { G[t.getAttribute('data-slg')] = t; });
      return G;
    }).catch(function () { G = {}; return G; });
    return GP;
  }
  function swap() {
    if (!G) return;
    document.querySelectorAll('ul[data-slg-k]').forEach(function (u) {
      var t = G[u.getAttribute('data-slg-k')]; if (!t) return;
      var frag = document.importNode(t.content, true), nu = frag.querySelector('ul'); if (!nu) return;
      u.parentNode.replaceChild(nu, u);
    });
  }
  function hydrate(root) {
    if (!root || !root.querySelectorAll) return;
    var any = false;
    root.querySelectorAll('template[data-sl-lazy]').forEach(function (t) {
      t.parentNode.replaceChild(document.importNode(t.content, true), t); any = true;
    });
    if (any || root.querySelector('ul[data-slg-k]')) grids().then(swap);
  }
  window.slHydrateMenu = hydrate;
  /* v350 (2026-10-31): menu gec geliyordu (izgara ilk acilista isteniyordu). Sayfa yuklendikten ~1,5 sn sonra arka planda onceden alinir;
     menu dugmesine dokunulunca / fare menuye gelince de hemen istenir. Boylece menu acildiginda hazir, sayfa HTML'i yine kucuk. */
  function warm() { grids().then(function () { var M = window._slImgMap; }); }
  window.addEventListener('load', function () { (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(warm, { timeout: 2500 }); });
  document.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('[aria-controls="MenuDrawer"], .header__menu, menu-drawer, .menu-drawer')) warm(); }, { passive: true, capture: true });
  document.addEventListener('pointerover', function (e) { if (e.target.closest && e.target.closest('.header__menu')) warm(); }, { passive: true });
  /* v347: masaustu mega menu resimleri de ayni bolumden: link adresine gore resim bulunur, linkin basina eklenir */
  window.slMenuImgs = function (li) {
    grids().then(function () {
      var M = window._slImgMap; if (!M) { M = window._slImgMap = {}; Object.keys(G).forEach(function (k) { G[k].content.querySelectorAll('a[href]').forEach(function (a) { var im = a.querySelector('img'); if (im) M[a.getAttribute('href')] = im.getAttribute('src'); }); }); }
      li.querySelectorAll('.menu-sidebar__content a.reversed-link').forEach(function (a) {
        if (a._slImg) return; a._slImg = 1; var src = M[a.getAttribute('href')]; if (!src) return;
        var w = document.createElement('div'); w.className = 'overflow-hidden blocks-radius-md';
        w.innerHTML = '<div class="block"><div class="media-wrapper" style="--aspect-ratio: 1/1;"><img src="' + src + '" alt="" loading="lazy" width="300" height="300" class="motion-reduce hover-scale-up"></div></div>';
        a.insertBefore(w, a.firstChild);
      });
    });
  };
  /* Sadece kategori basliklari (cekmecenin kendisi degil): o kategorinin izgaralari eklenir */
  var SEL = 'details[is="menu-drawer-details"], details.accordion-details';
  function target(el) { return el && el.matches && el.matches(SEL) && el.closest('menu-drawer, .menu-drawer') ? el : null; }
  /* Tiklama, details acilmadan ONCE gelir: icerik hazir olur, akordeon yuksekligi dogru hesaplanir */
  document.addEventListener('click', function (e) {
    var s = e.target && e.target.closest && e.target.closest('summary');
    var d = s && target(s.parentNode);
    if (d) hydrate(d);
  }, true);
  document.addEventListener('toggle', function (e) {
    var d = target(e.target);
    if (d && d.open) hydrate(d);
  }, true);
})();

/* SWORDSLIFE-OZEL (2026-10-09) HIZ: masaustu mega menu koleksiyon resimleri <template data-sl-mega> icinde gelir
   (snippets/mega-menu.liquid). Sadece fare / klavye o menu basligina gelince O MENUNUN resimleri eklenir.
   Onceden her sayfada 430 menu resmi (~16 MB) iniyordu; telefonda hic eklenmez. */
(function () {
  function hydrate(root) {
    root.querySelectorAll('template[data-sl-mega]').forEach(function (t) {
      t.parentNode.replaceChild(document.importNode(t.content, true), t);
    });
  }
  function onEnter(e) {
    var li = e.target && e.target.closest && e.target.closest('.header__menu li');
    if (!li || li._slMega) return;
    li._slMega = true;
    hydrate(li);
    if (window.slMenuImgs && window.matchMedia('(min-width: 1024px)').matches) window.slMenuImgs(li);
  }
  document.addEventListener('pointerover', onEnter, { passive: true });
  document.addEventListener('focusin', onEnter);
})();

/* SWORDSLIFE-OZEL (2026-10-09): Shop/Google profil resmi. header.liquid'deki gizli <shopify-account class="sl-shop-ava-src">
   bileseninin icinden (acik shadow DOM) profil resmi ya da harf rengi okunur, window.slShopAva'ya yazilir ve
   slAvatar ile tum [data-sl-avatar] alanlarina uygulanir. Musteri kendi resmini yuklediyse o oncelikli. */
(function () {
  function cidNow() { var n = document.querySelector('[data-sl-cid],[data-cid]'); return n ? (n.getAttribute('data-sl-cid') || n.getAttribute('data-cid')) : ''; }
  function walk(root, out) {
    root.querySelectorAll('*').forEach(function (e) { out.push(e); if (e.shadowRoot) walk(e.shadowRoot, out); });
    return out;
  }
  function clsOf(e) { var c = e.getAttribute('class') || ''; return (c + ' ' + (e.getAttribute('part') || '')).toLowerCase(); }
  /* sadece "avatar" baglamindaki ogeler (dukkan logosu vb. karismasin) */
  function inAvatar(e) {
    for (var i = 0, n = e; i < 4 && n && n.getAttribute; i++, n = n.parentNode) {
      var c = clsOf(n);
      if (c.indexOf('signed-out') >= 0) return false;
      if (c.indexOf('avatar') >= 0) return true;
    }
    return false;
  }
  function read(src) {
    var sr = src.shadowRoot; if (!sr) return null;
    var all = walk(sr, []);
    window.slShopAvaDebug = sr.innerHTML.replace(/<style[\s\S]*?<\/style>/g, '').slice(0, 3000);
    for (var i = 0; i < all.length; i++) {
      var e = all[i];
      if (e.tagName === 'IMG' && e.src && !/^data:image\/svg/i.test(e.src) && inAvatar(e)) return { img: e.src };
    }
    for (var j = 0; j < all.length; j++) {
      var a = all[j];
      if (!inAvatar(a)) continue;
      var t = (a.textContent || '').trim();
      if (t.length !== 1) continue;
      var cs = getComputedStyle(a), bg = cs.backgroundColor;
      /* harf rengi artik kullanilmiyor (sadece gercek resim) */
    }
    return null;
  }
  function start() {
    var src = document.querySelector('shopify-account.sl-shop-ava-src');
    var cid = cidNow();
    if (!src || !cid || !window.slAvatar) return;
    var k = 'sl_shop_ava2_' + cid; /* v2: eski (siyah renkli) kayit kullanilmasin */
    try { var c = sessionStorage.getItem(k); if (c) { window.slShopAva = JSON.parse(c); window.slAvatar.applyAll(true); return; } } catch (e) {}
    var n = 0;
    (function poll() {
      var r = read(src);
      if (r) {
        window.slShopAva = r;
        try { sessionStorage.setItem(k, JSON.stringify(r)); } catch (e) {}
        window.slAvatar.applyAll(true);
        return;
      }
      if (++n < 40) setTimeout(poll, 300);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* SWORDSLIFE-OZEL (2026-10-09): telefonda ust menu ovallerine (favori, hesap, sepet) basinca renkli cizgi bir tur doner.
   Masaustunde hover ile zaten doner (swordslife-custom.css). Stil: .sl-tap */
(function () {
  var desk = window.matchMedia('(min-width: 1024px) and (hover: hover)');
  document.addEventListener('pointerdown', function (e) {
    if (desk.matches) return;
    var p = e.target && e.target.closest && e.target.closest('.header .hp-pill, .header .account-pill');
    if (!p) return;
    p.classList.remove('sl-tap'); void p.offsetWidth; p.classList.add('sl-tap');
    clearTimeout(p._slTap);
    p._slTap = setTimeout(function () { p.classList.remove('sl-tap'); }, 1300);
  }, { passive: true });
})();
